module.exports = __webpack_public_path__ + "static/media/25.0c26d0be.png";